var Cookies = require("js-cookie");
var MD5 = require("js-md5");
var CryptoJSNew = require("crypto-js");
var base64Lib = require("min-base64");
var message = require("./message");

var avatarColors = ["#4eb4ed", "#FFEBEE", "#E0F2F1", "#008EFF"];
var intervals = [];
module.exports = {
  baseURI: "",
  redirectTo: function (url) {
    console.log("Redirect to" + this.baseURI + url);
    location.replace(this.baseURI + url);
  },
  message: function (key, msg) {
    message.messageG(key, msg);
  },
  alert: function (msg, callback) {
    message.alert(msg, callback);
  },
  errorAlert: function (msg, callback) {
    message.errorAlert(msg, callback);
  },
  confirmAlert: function (msg, callback) {
    message.confirmAlert(msg, callback);
  },
  getLan: function () {
    return Cookies.get("language") ? Cookies.get("language") : "en_US";
  },
  prefix: "/auth",
  fetch: function (url, options, errorFuntion) {
    var resultData;
    url = this.baseURI + url;
    options = options ? options : {};
    if (options.query !== undefined) {
      var esc = encodeURIComponent;
      var query = "";
      for (var key in options.query) {
        if (options.query[key] !== undefined && options.query[key] !== null) {
          query += esc(key) + "=" + esc(options.query[key]) + "&";
        }
      }
      query = query.substring(0, query.length - 1);
      url += "?" + query;
      delete options.query;
    }
    var rt = Cookies.get("rt") ? Cookies.get("rt") : "";
    var timestamp = new Date().getTime();
    var key = MD5(rt + timestamp);
    if (options.dataType === undefined) {
      options.dataType = "json";
    }
    options.contentType = "application/json";
    options.headers = {
      "tencent-Request-Key": key,
      "tencent-Request-T": timestamp,
    };
    options.url = url;
    if (!options.success) {
      options.success = function (data) {
        resultData = data;
      };
    }
    if (options.async === undefined) {
      options.async = false;
    }
    if (!options.data) {
      options.data = {};
    }
    if (!options.error) {
      options.error = function (data) {
        console.log(data);
        if (errorFuntion) {
          errorFuntion(data);
        } else {
          message.errorAlert(JSON.parse(data.responseText).message);
        }
      };
    }
    options.type = options.type ? options.type : options.method;
    options.data.randomP = this.genRandomP();
    console.log(options);
    $.ajax(url, options);
    return resultData;
  },
  genRandomP: function () {
    var random = Math.random() + "";
    random = random.substr(0, 6);
    return random + MD5(random + "i_a_m");
  },
  base64: {
    encode: function (input) {
      return base64Lib.btoa(input);
    },
  },
  sm2: {
    doCrypt: function (pubkeyHex, password) {
      var passwordData = CryptoJS.enc.Utf8.parse(password);
      console.info("password", passwordData);
      var cipher = new SM2Cipher(1);
      var userKey = cipher.CreatePoint(pubkeyHex);
      passwordData = cipher.str2Bytes(passwordData.toString());
      var encryptData = cipher.Encrypt(userKey, passwordData);
      return encryptData;
    },
    Decrypt: function (prvkey, ciphertext) {
      var privateKey = new BigInteger(prvkey, 16);
      var cipher = new SM2Cipher(1);
      var data = cipher.Decrypt(privateKey, ciphertext);
      return data;
    },
  },
  des: {
    encrypt: function (data, key) {
      return CryptoJSNew.DES.encrypt(data, CryptoJSNew.enc.Utf8.parse(key), {
        mode: CryptoJSNew.mode.ECB,
        padding: CryptoJSNew.pad.Pkcs7,
      }).toString();
    },
    decrypt: function (data, key) {
      return CryptoJSNew.DES.decrypt(data, CryptoJSNew.enc.Utf8.parse(key), {
        mode: CryptoJSNew.mode.ECB,
        padding: CryptoJSNew.pad.Pkcs7,
      }).toString(CryptoJSNew.enc.Utf8);
    },
  },
  log: function (message) {
    if (console) {
      console.log(message);
    } else {
      alert(message);
      // $("#log").append("<p>" + message + "</p>");
    }
  },
  renderMain: function (html) {
    $("#main").html(html);
  },
  fixPlaceholder: function (formItem) {
    if (!Modernizr.placeholder) {
      if (formItem.placeholder) {
        var input = $("#" + formItem.id);
        var placeholder = $(
          "<div class='placeholderDiv'>" + formItem.placeholder + "</div>"
        );
        if (input.val()) {
          placeholder.hide();
        }
        input.before(placeholder);

        input.focus(function () {
          placeholder.hide();
        });
        input.blur(function () {
          if (!input.val()) {
            placeholder.show();
          }
        });
        input.change(function () {
          if (input.val()) {
            placeholder.hide();
          }
        });

        placeholder.click(function () {
          input.trigger("focus");
        });
      }
    }
  },
  fixIE: function () {
    // $("#loading").show();
    // $("#main").hide();
    setTimeout(function () {
      // fixPlaceholder();
      // var ie = $("body").append("<div id='fixIE'><!--[if lt IE 9]>\n" +
      //     "<script type=\"text/javascript\" src=\"/public/scripts/IE9.js\"></script>\n" +
      //     "<!--<![endif]--><div>")
      // $("#fixIE").remove();
    }, 10);
    // setTimeout(function () {
    //     $("#main").show();
    //     $("#loading").hide();
    // }, 1)
  },
  fixResizeIssue: function () {
    this.hideAndShow($(".loginTab"));
  },
  hideAndShow: function (jqe) {
    jqe.hide();
    jqe.show();
  },
  unscape: function (str) {
    var elem = document.createElement("textarea");
    elem.innerHTML = str;
    var decoded = elem.value;
    return decoded;
  },
  //validFrom
  validFrom: function (values) {
    if (values) {
      for (var i in values) {
        if (values[i] == "" || values[i] == undefined || values[i] == null) {
          delete values[i];
        }
      }
    }
    return values;
  },
  validate: function (value, rules, name) {
    if (rules) {
      //console.log(rules)
      for (var i in rules) {
        if (typeof rules[i] == "string") {
          switch (rules[i]) {
            case "require":
              if (value !== false && !value) {
                return { valid: false, msg: commonLocal.describe.required };
              }
              break;
            case "number":
              if (value && !value.toString().match(/^(-?\d+)(\.\d+)?$/)) {
                return { valid: false, msg: "必须是数字" };
              }
              break;
            case "phone":
              if (value && !value.match(/^1\d{10}$/)) {
                return {
                  valid: false,
                  msg: commonLocal.describe.IncorrectFormatOfMobilePhoneNumber,
                };
              }
              break;
            case "email":
              if (
                value &&
                !value.match(
                  /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,20}(\.[a-z]{2,20})?)$/
                )
              ) {
                return {
                  valid: false,
                  msg: commonLocal.describe.ItHasToBeANumber,
                };
              }
              break;
            case "idNumber":
              if (
                value &&
                !value.match(
                  /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
                )
              ) {
                return {
                  valid: false,
                  msg: commonLocal.describe.PleaseEnterAValidIDNumber,
                };
              }
              break;
            case "global":
              if (
                value &&
                !value.match(
                  /^[\u4E00-\u9FA5A-Za-z0-9._-]+$|^[a-zA-Z0-9]+@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*\.[a-zA-Z0-9]{2,}$/
                )
              ) {
                return {
                  valid: false,
                  msg: commonLocal.describe
                    .EmailOrInChineseEnglishNumbersUnderscoresAndHorizontalLines,
                };
              }
              break;
            default:
              if (rules[i].match(/^same-/)) {
                var another = $(
                  "input[name='" + rules[i].replace("same-", "") + "']"
                );
                if (another.val() !== value) {
                  return {
                    valid: false,
                    msg: commonLocal.describe.TheTwoPasswordsAreInconsistent,
                  };
                }
              } else if (rules[i].match(/^fixed-/)) {
                var l = Number(rules[i].replace("fixed-", ""));
                if (value.length != l) {
                  return {
                    valid: false,
                    msg:
                      commonLocal.describe.ItHasToBe +
                      l +
                      commonLocal.describe.digit,
                  };
                }
              } else {
                alert(
                  rules[i] +
                    commonLocal.describe.IsAnUnsupportedFormValidationType
                );
              }
          }
        } else {
          if (rules[i].regexStr) {
            value = value + "";
            if (value && !value.match(new RegExp(rules[i].regexStr))) {
              return {
                valid: false,
                msg: rules[i].regexHintMsg
                  ? rules[i].regexHintMsg
                  : commonLocal.describe.RegularVerificationFailed,
              };
            }
          }
          if (rules[i].maxLength) {
            value = value + "";
            if (
              value &&
              !value.match(
                new RegExp("^[\\s\\S]{0," + rules[i].maxLength + "}$")
              )
            ) {
              return {
                valid: false,
                msg:
                  commonLocal.describe.InputCannotExceed +
                  rules[i].maxLength +
                  commonLocal.describe.character,
              };
            }
          }
          if (rules[i].minLength) {
            value = value + "";
            if (
              value &&
              !value.match(
                new RegExp("^[\\s\\S]{" + rules[i].minLength + ",}$")
              )
            ) {
              return {
                valid: false,
                msg:
                  commonLocal.describe.InputCannotBeLessThan +
                  rules[i].minLength +
                  commonLocal.describe.character,
              };
            }
          }
        }
      }
      return { valid: true };
    } else {
      return { valid: true };
    }
  },
  validateAll: function (items) {
    for (var i in items) {
      var item = items[i];
      var result = item.validate && item.validate();
      if (result && result.valid === false) {
        return {
          valid: false,
          msg:
            commonLocal.describe.PleaseCheck +
            item.displayName +
            ":" +
            result.msg,
        };
      }
    }
    return { valid: true };
  },
  validateEachAll: function (items) {
    for (var i in items) {
      var item = items[i].formItems && items[i].formItems[0];
      var result = item.validate && item.validate();
      if (result.valid === false) {
        return {
          valid: false,
          msg:
            commonLocal.describe.PleaseCheck +
            item.displayName +
            ":" +
            result.msg,
        };
      }
    }
    return { valid: true };
  },
  randomColor: function (value) {
    return avatarColors[value.charCodeAt(0) % avatarColors.length];
  },
  addInterval: function (fn, time) {
    var interval = setInterval(fn, time);
    intervals.push(interval);
    return interval;
  },
  clear: function () {
    for (var i in intervals) {
      clearInterval(intervals[i]);
    }
    intervals = [];
  },
  initStorage: function (data) {
    var currentId = data.individualId;
    sessionStorage.setItem("currentId", currentId);
    profile = { user: data, appDefaultEntitlement: {} };
    sessionStorage.setItem("profile-" + currentId, JSON.stringify(profile));
    //需要切换用户,所以每次getUser都存一次
    // var profile = sessionStorage.getItem('profile-' + currentId);
    // if (!profile) {
    //     profile = {user: data, appDefaultEntitlement: {}};
    //     sessionStorage.setItem('profile-' + currentId, JSON.stringify(profile));
    // }
  },
  getStorage: function () {
    var currentId = sessionStorage.getItem("currentId");
    var profile = sessionStorage.getItem("profile-" + currentId);
    return JSON.parse(profile);
  },
  initProfile: function (data) {
    var currentId = data.individualId;
    //Cookies.remove('profile-' + currentId);
    Cookies.set("currentId", currentId);
    var profile = Cookies.getJSON("profile-" + currentId);
    if (!profile) {
      profile = { user: data, appDefaultEntitlement: {} };
      Cookies.set("profile-" + currentId, profile, { expires: 3650 });
    }
  },
  getProfile: function () {
    var currentId = Cookies.get("currentId");
    var profile = Cookies.getJSON("profile-" + currentId);
    return profile;
  },
  setProfile: function (profile) {
    var currentId = Cookies.get("currentId");
    Cookies.set("profile-" + currentId, profile, { expires: 3650 });
  },
  URIEncode: function (text) {
    return encodeURI(text);
  },
  getURLParameter: function (name) {
    return (
      decodeURIComponent(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.href
        ) || [null, ""])[1].replace(/\+/g, "%20")
      ) || null
    );
  },
  browserInfo: function () {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: "IE", version: tem[1] || "" };
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return { name: "Opera", version: tem[1] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: new Number(M[1]),
    };
  },
  //计算距离现在的天时分数
  selectTimes: function (time) {
    var aTime = typeof time === "number" ? time : new Date(time);
    var timestamp = Date.parse(new Date());
    var nTime = Math.abs(timestamp - aTime);
    var day = Math.round(nTime / (1000 * 60 * 60 * 24));
    var hour = Math.round(nTime / (1000 * 60 * 60));
    var minute = Math.round(nTime / (1000 * 60));
    var second = Math.round(nTime / 1000);
    if (nTime > 1000 * 60 * 60 * 24) {
      return day + "天";
    } else if (nTime > 1000 * 60 * 60) {
      return hour + "小时";
    } else if (nTime > 1000 * 60) {
      return minute + "分钟";
    } else {
      return second + "秒";
    }
  },
  //时间戳转时间格式
  timestampToTime: function (timestamp, type) {
    if (timestamp == null) {
      return "";
    }
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    Y = date.getFullYear() + "-";
    M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    //D = date.getDate() + ' ';
    D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
    h =
      date.getHours() < 10
        ? "0" + date.getHours() + ":"
        : date.getHours() + ":";
    m =
      date.getMinutes() < 10
        ? "0" + date.getMinutes() + ":"
        : date.getMinutes() + ":";
    s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    //m = date.getMinutes() + ':';
    //s = date.getSeconds();
    if (type == "day") {
      return Y + M + D;
    }
    if (type == "minute") {
      return Y + M + D + h + m;
    }
    return Y + M + D + h + m + s;
  },
  //期限判断
  termRender: function (enabled, activeDate, expireDate) {
    var timestamp = Date.parse(new Date());
    if (enabled) {
      if (!expireDate) {
        return commonLocal.describe.LongTermValidity;
      }
      if (activeDate) {
        if (timestamp < activeDate) {
          return (
            this.selectTimes(activeDate) + commonLocal.describe.TakeEffectAfter
          );
        }
      }
      if (expireDate) {
        if (timestamp > expireDate) {
          return this.selectTimes(expireDate) + commonLocal.describe.Invalid;
        } else {
          return (
            this.selectTimes(expireDate) + commonLocal.describe.PostFailure
          );
        }
      }
    } else {
      return commonLocal.describe.Disabled;
    }
  },
  urlSearch: function (str) {
    var obj = {};
    var name;
    var value;
    var num = str.indexOf("?");
    str = str.substr(num + 1);
    var arr = str.split("&");
    for (var i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("=");
      if (num > 0) {
        name = arr[i].substring(0, num);
        value = arr[i].substr(num + 1);
        obj[name] = value;
      }
    }
    return obj;
  },
  objToSearchUrl: function (obj) {
    var str = "";
    for (var key in obj) {
      str += key + "=" + obj[key] + "&";
    }
    return str;
  },
  //转换认证类型
  getAuthType: function (type) {
    var typeText = "";
    switch (type) {
      case "NOAUTH":
        typeText = commonLocal.describe.NoCertification;
        break;
      case "LASTAUTH":
        typeText = commonLocal.describe.LastCertification;
        break;
      case "PASSWORD":
        typeText = commonLocal.describe.Password;
        break;
      case "QR_CODE":
        typeText = commonLocal.describe.QRCode;
        break;
      case "FINGERPRINT":
        typeText = commonLocal.describe.fingerprint;
        break;
      case "DYNAMICCODE":
        typeText = commonLocal.describe.DynamicCode;
        break;
      case "SMS":
        typeText = commonLocal.describe.ShortMessage;
        break;
      case "EMAIL":
        typeText = commonLocal.describe.Mail;
        break;
    }
    return typeText;
  },
  createRules: function (params) {
    var rules = [];
    switch (params.type) {
      case "String":
        if (params.code == "idNumber") {
          rules = params.required ? ["require", "idNumber"] : ["idNumber"];
        } else {
          rules = params.required ? ["require"] : [];
        }
        break;
      case "Phone":
        rules = params.required ? ["require", "phone"] : ["phone"];
        break;
      case "Email":
        rules = params.required ? ["require", "email"] : ["email"];
        break;
      case "Number":
        rules = params.required ? ["require", "number"] : ["number"];
        break;
      default:
        rules = params.required ? ["require"] : [];
    }
    if (params.metaPropertyRegex) {
      rules.push({
        regexStr: params.regexStr,
        regexHintMsg: params.regexHintMsg,
      });
    }
    if (params.metaPropertyLength) {
      rules.push({ maxLength: params.maxLength, minLength: params.minLength });
    }
    return rules;
  },
  arrayToObject: function (values) {
    var array = [];
    for (var i in values) {
      array.push({
        name: i,
        value: values[i],
      });
    }
    return array;
  },
  preventBubble: function () {
    var e = arguments.callee.caller.arguments[0] || event; //若省略此句，下面的e改为event，IE运行可以，但是其他浏览器就不兼容
    if (e && e.stopPropagation) {
      e.stopPropagation();
    } else if (window.event) {
      window.event.cancelBubble = true;
    }
  },
  refreshNode: function () {
    var $this = this;
    $this.fetch("/auth/authNode", {
      type: "GET",
      success: function (result) {
        console.log(result);
        if (result.data) {
          localStorage.setItem("authNode", JSON.stringify(result.data));
          if (result.data.loginTemplate) {
            var login_style = $this.getURLParameter("login_style");
            // 如果url中有login_style参数，且为IOA
            if (login_style === "IOA") {
              localStorage.setItem("loginTemplate", "smallConcise");
            } else {
              localStorage.setItem("loginTemplate", result.data.loginTemplate);
            }
          }
          var url = "/auth/uploadFile/previewFile/";
          if (result.data.logoImage) {
            sessionStorage.setItem("logo", url + result.data.logoImage);
          }
          if (result.data.headerLogo) {
            sessionStorage.setItem("headerLogo", url + result.data.headerLogo);
          }
          if (result.data.bgImage) {
            sessionStorage.setItem("bgImage", url + result.data.bgImage);
          }
          if (result.data.copyright) {
            sessionStorage.setItem("copyright", result.data.copyright);
          }
          if (result.data.title) {
            document.title = result.data.title;
          }
          if (result.data.icon) {
            sessionStorage.setItem("icon", url + result.data.icon);
            $this.changeFavicon(url + result.data.icon);
          }
        }
      },
    });
  },
  changeFavicon: function (link) {
    var $favicon = document.querySelector('link[rel="icon"]');
    // If a <link rel="icon"> element already exists,
    // change its href to the given link.
    if ($favicon !== null) {
      $favicon.href = link;
      // Otherwise, create a new element and append it to <head>.
    } else {
      $favicon = document.createElement("link");
      $favicon.rel = "icon";
      $favicon.href = link;
      document.head.appendChild($favicon);
    }
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/utiles/common.js
// module id = 0
// module chunks = 0